module.exports = __webpack_public_path__ + "static/media/calendarBlueIcon.53a5cda0.svg";